<template>
  <div class="container-fluid">
    <!-- {{packageConfigs}} -->
    <div
      style="
        display: flex;
        align-content: center;
        text-align: left;
        margin-left: auto;
        border: 1pt black dotted;
        margin-right: auto;
        width: 80%;
        background: #fff;
        padding-left: 5%;
        padding-right: 5%;
      "
    >
      <div class="col-sm-12">
        <h3>
          {{
            form.invoiceType == "initial" ? `Send Invoice` : `Create Request`
          }}
        </h3>
        <hr />
        <el-form
          class="form"
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item class="form-item" label="Type">
            <el-select
              style="width: 100%"
              v-model="form.invoiceType"
              @change="changeContact"
              id="customer-invoice"
              placeholder="--Customer Type--"
            >
              <el-option label="New" value="initial"></el-option>
              <el-option label="Existing" value="existing"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="form-item" label="Owner">
            <el-autocomplete
              style="width: 100%"
              id="customer-contact"
              class="inline-input"
              v-model="form.contact"
              :fetch-suggestions="contactSearch"
              placeholder="Search contact"
              prefix-icon="el-icon-search"
              @select="contactSelected"
            ></el-autocomplete>
          </el-form-item>

          <el-form-item class="form-item" label="Industry sector">
            <el-autocomplete
              style="width: 100%"
              id="sector-select"
              class="inline-input"
              v-model="form.sector"
              :fetch-suggestions="sectorSearch"
              placeholder="Select sector"
              prefix-icon="el-icon-suitcase"
              @select="sectorSelected"
            ></el-autocomplete>
          </el-form-item>

          <el-form-item class="form-item" label="Installation Name">
            <el-input
              style="width: 100%"
              id="customer-name"
              v-model="regDataParams.deviceRequest.installationName"
              :min="1"
            ></el-input>
          </el-form-item>

          <el-form-item class="form-item" label="Date">
            <el-date-picker
              style="width: 100%"
              v-model="regDataParams.deviceRequest.filterDate"
              type="datetimerange"
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              align="center"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="form-item" label="Address">
            <el-input
              style="width: 100%"
              id="customer-address"
              v-model="regDataParams.deviceRequest.address"
              :min="1"
            ></el-input>
          </el-form-item>
          <el-form-item class="form-item" label="Proposed Location">
            <el-input
              style="width: 100%"
              id="customer-address"
              v-model="regDataParams.deviceRequest.proposedLocation"
              :min="1"
            ></el-input>
          </el-form-item>

          <el-form-item class="form-item" label="Package">
            <el-select
              style="width: 100%"
              v-model="form.package"
              placeholder="Package"
              @change="packageSelected"
            >
              <el-option
                v-for="(item, index) in systemTypes"
                :key="`${item.id}_package_${index}`"
                :label="item.name"
                :value="item.id"
                style="height: 55px"
              >
                <!-- style="height: 60px; line-height: 10px;" -->
                <h4 style="float: left; margin: 0px">{{ item.name }}</h4>
                <span
                  style="
                    float: left;
                    color: #8492a6;
                    font-size: 13px;
                    line-height: 20px;
                  "
                  >{{ item.description }}</span
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-item" label="System Capacity(KW)">
            <!-- <el-input placeholder="Please input" v-model="regDataParams.deviceRequest.systemCapacity"> -->
            <el-input-number
              v-model="regDataParams.deviceRequest.systemCapacity"
              controls-position="right"
              :min="5"
              style="width: 100%"
              :max="1000"
            ></el-input-number>

            <!-- </el-input> -->
          </el-form-item>
          <el-form-item class="form-item" label="Payment Model">
            <el-radio-group
              v-model="regDataParams.deviceRequest.paymentModel"
              @change="calculatePayment"
            >
              <el-radio :label="`OS`">OS</el-radio>
              <el-radio :label="`LO`">LO</el-radio>
              <el-radio :label="`ES`">ES</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- `OS` -->
          <el-form-item class="form-item" label>
            <div v-if="regDataParams.deviceRequest.paymentModel == `OS`">
              <el-form-item class="form-item" label="Base price(₦)">
                <el-input-number
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.amount"
                  :min="1"
                ></el-input-number>
              </el-form-item>
            </div>
            <div v-if="regDataParams.deviceRequest.paymentModel == `LO`">
              <el-form-item class="form-item" label="Setup Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.setupFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>

              <el-form-item class="form-item" label="Monthly Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.monthlyFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>

              <el-form-item class="form-item" label="Caution Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.cautionFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>
            </div>
            <div v-if="regDataParams.deviceRequest.paymentModel == `ES`">
              <el-form-item class="form-item" label="Setup Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.setupFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>

              <el-form-item class="form-item" label="Monthly Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.monthlyFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>

              <el-form-item class="form-item" label="Caution Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.cautionFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item class="form-item" label="VAT">
            <el-select
              v-model="regDataParams.deviceRequest.priceModel.orderVat"
              placeholder="Select"
              style="width: 100px"
              @change="calculatePayment"
            >
              <el-option
                :key="`7_5_item_vat_list`"
                :label="`7.5%`"
                :value="7.5"
              ></el-option>
              <el-option
                :key="`0_0_item_vat_list`"
                :label="`0.0%`"
                :value="0.0"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="form-item"
            v-if="regDataParams.deviceRequest.paymentModel == `LO`"
            label="Discount"
          >
            <el-select
              v-if="discountType == `percent`"
              v-model="regDataParams.deviceRequest.orderDiscount"
              placeholder="Select"
              style="width: 100px"
              @change="calculatePayment"
            >
              <el-option
                v-for="item in 101"
                :key="`discoutnt_${item}_item_list`"
                :label="item - 1 + '%'"
                :value="item - 1"
              ></el-option>
            </el-select>
            <el-input-number
              v-else
              style="width: 180px"
              id="customer-price"
              v-model="regDataParams.deviceRequest.amountDiscount"
              :min="1"
            ></el-input-number>
          </el-form-item>

          <el-form-item class="form-item" label="Title">
            <el-input
              style="width: 100%"
              id="customer-address"
              v-model="regDataParams.deviceRequest.title"
              :min="1"
            ></el-input>
          </el-form-item>
          <el-form-item class="fo​​rm-item" label="Description">
            <el-input
              type="textarea"
              :autosize="{ minRows: 8, maxRows: 12 }"
              placeholder="Please input"
              v-model="regDataParams.deviceRequest.comment"
            ></el-input>
            <!-- <el-input type="texta​​rea"  autosize :rows="3" id="customer-description" v-model="form.desc"></el-input> -->
          </el-form-item>
          <el-form-item class="fo​​rm-item" label="Terms">
            <el-input
              type="textarea"
              :autosize="{ minRows: 8, maxRows: 12 }"
              placeholder="Please input"
              v-model="regDataParams.deviceRequest.term"
            ></el-input>
            <!-- <el-input type="texta​​rea"  autosize :rows="3" id="customer-description" v-model="form.desc"></el-input> -->
          </el-form-item>
          <div class="form-group col-md-12">
            <label for="p-signup-email">Send Invoice</label>
            <el-switch
              style="width: 100%"
              v-model="regDataParams.deviceRequest.sendMail"
              active-text="Send Invoice"
              inactive-text="Don't send Invoice"
            ></el-switch>
          </div>
          <div style="display: flex; width: 100%">
            <el-form-item>
              <el-button
                type="prim​​ary"
                class="customer-btn"
                :disabled="loading"
                @click="onSubmit()"
                >Create</el-button
              >
            </el-form-item>
          </div>
        </el-form>
        <!-- {{systemTypes}} -->
      </div>
    </div>
  </div>
</template>
<script>
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { mapGetters, mapActions } from "vuex";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";
import sectorList from "@/mockData/sectors.json";
export default {
  name: "add-subs",
  props: {
    toggleAdd: {
      type: Function
    },
    getSubs: {
      type: Function
    },
    showOffCanvas: {
      type: Boolean,
      default: false
    },
    installationList: {
      type: Array
    }
  },
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {
    ...mapGetters(["getUserSession"]),
    paymentModel() {
      return this.regDataParams.deviceRequest.paymentModel;
    }
  },
  data: function() {
    return {
      loading: false,
      regDataParams: {
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null,
        deviceRequest: {
          sector: "",
          installationName: "",
          paymentModel: "OS",
          priceModel: {
            amount: "4279069.77",
            orderVat: 7.5,
            setupFee: "",
            monthlyFee: "",
            cautionFee: "",
            grandTotal: ""
          },
          proposedLocation: "",
          term: "",
          filterDate: [],
          systemCapacity: 5,
          orderVat: 7.5,
          orderDiscount: 0,
          typeOfBuilding: "Normal",
          roofType: "Aluminium",
          roofCondition: "Very Good",
          roofReadiness: "Very Ready",
          roofAge: 4,
          roofComment: "No comment here	Roof is ready for installation",
          deviceTypeId: null,
          comment: null,
          title: "Outright sale",
          comment:
            "Design, Installation, Commissioning and Managed Service of a 4.5KW Solar PV System with 10.8kWh Lithium Storage",
          sendMail: true
        }
      },
      discountType: "percent",
      ZcontactList: [],
      selectedPaymentModel: [],
      packageConfigs: [],
      zohoToken: {},
      zohoModules: [],
      systemTypes: [],
      contactList: [],
      form: {
        userId: null,
        package: null,
        sector: "",
        contact: "",
        invoiceType: "initial",
        paymentModel: {
          name: "",
          setupFee: "",
          monthlyFee: "",
          cautionFee: "",
          orderDiscount: "",
          orderVat: 7.5
        },
        desc: ""
      }
    };
  },
  methods: {
    calculatePayment() {
      let ctx = this;
      let { paymentModel } = ctx.regDataParams.deviceRequest;
      let { comment, title } = ctx.getComment(paymentModel);
      ctx.regDataParams.deviceRequest.comment = comment;
      ctx.regDataParams.deviceRequest.title = title;
      switch (paymentModel) {
        case "OS":
          ctx.regDataParams.deviceRequest.priceModel.amount = 4279069.77;
          ctx.regDataParams.deviceRequest.priceModel.amountVAT = ctx.getVatValue(
            ctx.regDataParams.deviceRequest.priceModel.amount,
            ctx.regDataParams.deviceRequest.priceModel.orderVat
          );
          ctx.regDataParams.deviceRequest.priceModel.grandTotal =
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.amount) +
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.amountVAT);

          ctx.regDataParams.deviceRequest.priceModel.amountPaymentB4Delivery = ctx.getVatValue(
            ctx.regDataParams.deviceRequest.priceModel.grandTotal,
            90
          );
          ctx.regDataParams.deviceRequest.priceModel.amountBalanceAfterInstalation = ctx.getVatValue(
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.grandTotal),
            10
          );
          console.error({ price: ctx.regDataParams.deviceRequest.priceModel });

          break;
        case "ES":
          ctx.regDataParams.deviceRequest.priceModel.setupFee = 366279.07;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFee = 75069.77;
          ctx.regDataParams.deviceRequest.priceModel.cautionFee = 225209.3;

          ctx.regDataParams.deviceRequest.priceModel.setupFeeVAT = ctx.getVatValue(
            ctx.regDataParams.deviceRequest.priceModel.setupFee,
            ctx.regDataParams.deviceRequest.priceModel.orderVat
          );
          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeVAT = ctx.getVatValue(
            ctx.regDataParams.deviceRequest.priceModel.monthlyFee,
            ctx.regDataParams.deviceRequest.priceModel.orderVat
          );
          ctx.regDataParams.deviceRequest.priceModel.cautionFeeVAT = ctx.getVatValue(
            ctx.regDataParams.deviceRequest.priceModel.cautionFee,
            ctx.regDataParams.deviceRequest.priceModel.orderVat
          );

          ctx.regDataParams.deviceRequest.priceModel.setupFeeGrandTotal =
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.setupFee) +
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.setupFeeVAT);

          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeGrandTotal =
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.monthlyFee) +
            parseFloat(
              ctx.regDataParams.deviceRequest.priceModel.monthlyFeeVAT
            );

          ctx.regDataParams.deviceRequest.priceModel.cautionFeeGrandTotal =
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.cautionFee) +
            parseFloat(
              ctx.regDataParams.deviceRequest.priceModel.cautionFeeVAT
            );

          console.error({ price: ctx.regDataParams.deviceRequest.priceModel });

          break;
        case "LO":
          ctx.regDataParams.deviceRequest.priceModel.setupFee = 366279.07;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFee = 154697.67;
          ctx.regDataParams.deviceRequest.priceModel.cautionFee = 154697.67;

          // Discoount
          console.error({
            orderDicount: ctx.regDataParams.deviceRequest.orderDiscount
          });

          ctx.regDataParams.deviceRequest.priceModel.setupFeeDiscount =
            ctx.regDataParams.deviceRequest.priceModel.setupFee;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeDiscount = ctx.getVatValue(
            ctx.regDataParams.deviceRequest.priceModel.monthlyFee,
            ctx.regDataParams.deviceRequest.orderDiscount
          );
          ctx.regDataParams.deviceRequest.priceModel.cautionFeeDiscount = ctx.getVatValue(
            ctx.regDataParams.deviceRequest.priceModel.cautionFee,
            ctx.regDataParams.deviceRequest.orderDiscount
          );

          // VAT
          ctx.regDataParams.deviceRequest.priceModel.setupFeeVAT = 0.0;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeVAT = ctx.getVatValue(
            ctx.regDataParams.deviceRequest.priceModel.monthlyFee,
            ctx.regDataParams.deviceRequest.priceModel.orderVat
          );
          ctx.regDataParams.deviceRequest.priceModel.cautionFeeVAT = ctx.getVatValue(
            ctx.regDataParams.deviceRequest.priceModel.cautionFee,
            ctx.regDataParams.deviceRequest.priceModel.orderVat
          );
          // Grand total
          ctx.regDataParams.deviceRequest.priceModel.setupFeeGrandTotal =
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.setupFee) -
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.setupFee);

          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeGrandTotal =
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.monthlyFee) +
            parseFloat(
              ctx.regDataParams.deviceRequest.priceModel.monthlyFeeVAT
            );

          ctx.regDataParams.deviceRequest.priceModel.cautionFeeGrandTotal =
            parseFloat(ctx.regDataParams.deviceRequest.priceModel.cautionFee) +
            parseFloat(
              ctx.regDataParams.deviceRequest.priceModel.cautionFeeVAT
            );

          ctx.regDataParams.deviceRequest.priceModel.cautionFeeGrandTotalPlusMonthlyFeeGrandTotal =
            parseFloat(
              ctx.regDataParams.deviceRequest.priceModel.cautionFeeGrandTotal
            ) +
            parseFloat(
              ctx.regDataParams.deviceRequest.priceModel.monthlyFeeGrandTotal
            );
          console.error({ price: ctx.regDataParams.deviceRequest.priceModel });
          break;

        default:
          ctx.regDataParams.deviceRequest.priceModel.amount = 0;
          ctx.regDataParams.deviceRequest.priceModel.setupFee = 0;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFee = 0;
          ctx.regDataParams.deviceRequest.priceModel.cautionFee = 0;
          break;
      }
    },
    getComment(paymentModel) {
      let response = {};
      switch (paymentModel) {
        case "ES":
          response.title = "Energy as a Service Purchase Setup";
          response.comment =
            "Design, Installation, Commissioning and Managed Service of an 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage";
          break;
        case "LO":
          response.title = "LEASE TO OWN SERVICE";
          response.comment =
            "Design, Installation, Commissioning and Managed Service of an 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage";
          break;
        case "OS":
          response.title = "Outright sale";
          response.comment =
            "Design, Installation, Commissioning and Managed Service of a 4.5KW Solar PV System with 10.8kWh Lithium Storage";
          break;

        default:
          response.title = "";
          response.comment = "";
          break;
      }
      return response;
    },
    getVatValue(val, percent = 7.5) {
      if (val != "" && val != null && typeof val != "undefined") {
        return ((parseFloat(val) * percent) / 100).toFixed(2);
      } else {
        return "";
      }
    },
    numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    async onSubmit() {
      if (this.form.package == null) {
        this.showErrorMsg({
          message: "Please select a device type"
        });
      } else if (this.form.sector == null) {
        this.showErrorMsg({
          message: "Please select an sector"
        });
      } else {
        this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
        // this.regDataParams.deviceRequest.orderDiscount = this.orderDiscount;
        // this.regDataParams.deviceRequest.orderVat = this.orderVat;
        let regDataParams = this.regDataParams;
        // let orderDiscount = this.orderDiscount;
        // let orderVat = this.orderVat;
        //console.log(this.contactList);
        //console.log(this.form);
        console.error({ regDataParams });
        Object.keys(regDataParams.deviceRequest.priceModel).forEach(
          (key, i) =>
            (regDataParams.deviceRequest.priceModel[
              key
            ] = this.numberWithCommas(
              parseFloat(regDataParams.deviceRequest.priceModel[key]).toFixed(2)
            ))
        );
        // console.error({ regDataParams });

        // return;
        const HTTP = this.$httpUtils.instance;
        console.log(JSON.stringify(regDataParams));
        this.loading = true;
        try {
          let resp =
            this.form.invoiceType == "initial"
              ? await HTTP.post("/users", regDataParams)
              : await HTTP.post("/device_requests", {
                  ...regDataParams.deviceRequest,
                  // status: 1,
                  priceModel: regDataParams.deviceRequest.priceModel,
                  status: this.regDataParams.deviceRequest.sendMail ? 0 : 1,
                  userId: this.form.userId
                });
          this.loading = false;
          this.showSuccessMsg({ message: "Request Submitted" });
          //   // this.activeTab="manage_requests";
          //   // this.renderManageComponent= true;
          this.showOffCanvas = false;
          this.toggleAdd();
          // this.$router.push({
          //   name: "devices",
          //   params: {
          //     activetab: "manage_requests"
          //   }
          // });
          //   this.$router.go();
        } catch (error) {
          this.loading = false;
          if (error.response) {
            if (error.response.data) {
              // console.log(error.response.data);
              let { details, message } = error.response.data.error;
              console.log({ message, details });

              let error_incomming =
                undefined !== message ? message : details.messages;
              // typeof error.response.data.error === undefined
              //   ? error.response.data.error.messages
              //   : error.response.data.error.details.messages;
              // error_incomming;
              console.log(error_incomming);
              if (typeof error_incomming === "string") {
                this.showErrorMsg({
                  message: error_incomming
                });
                return;
              }
              let tempMsg = Object.keys(error_incomming).map(
                x => `${x}: ${error_incomming[x].join(",")}`
              );
              this.showErrorMsg({
                message: tempMsg.join("<br>")
              });
            }
          }
          console.log({
            error
          });
        }

        // this.showOffCanvas=false;
        // this.$router.push({
        //   name: "devices",
        //   params: {
        //     activetab: "manage_requests"
        //   }
        // });
        // this.$router.go()

        // .then(resp => {
        //   console.log(resp);
        // })
        // .catch(function(error_incomming) {
        //   console.log(error_incomming);
        // let tempMsg = Object.keys(error_incomming["messages"]).map(
        //   x => `${x}: ${error_incomming[x].join(",")}`
        // );
        // this.showWarnMsg({
        //   message: tempMsg.join("<br>")
        // });
        // });
      }
    },
    logDate() {
      console.log({ data: this.form.filterDate });
    },
    changeContact() {
      // console.log({ customerList: this.customerList });

      this.form.invoiceType == "initial"
        ? (this.contactList = this.ZcontactList)
        : (this.contactList = this.customerList);
    },
    calcSetup(price) {
      let setupPercent = Number(this.selectedPaymentModel["Setup"]) / 100;
      // console.log( this.form.price);
      let temp_price = Number(setupPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcSub(price) {
      let subscriptionPercent =
        Number(this.selectedPaymentModel["Subscription"]) / 100;
      let temp_price = Number(subscriptionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcCaution(price) {
      let cautionPercent = Number(this.selectedPaymentModel["Caution"]) / 100;
      let temp_price = Number(cautionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    contactSearch(queryString, cb) {
      let contacts = this.contactList;
      var results = queryString
        ? contacts.filter(contact => this.createFilter(queryString, contact))
        : contacts;
      // console.log({ results });
      cb(results);
    },
    createFilter(queryString, contact) {
      return (
        `${contact.First_Name} ${contact.Last_Name}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSelected(contact) {
      this.regDataParams = {
        ...this.regDataParams,
        firstName: contact["First_Name"],
        lastName: contact["Last_Name"],
        phoneNumber: contact["Phone"],
        username: contact["Email"],
        email: contact["Email"]
      };
      this.regDataParams.deviceRequest.installationName = `${contact["First_Name"]} ${contact["Last_Name"]}`;
      if (this.form.invoiceType == "existing") {
        this.form.userId = contact["id"];
      }
    },
    createSectorFilter(queryString, sector) {
      console.log({ sector });
      return (
        `${sector.value.trim()}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    sectorSearch(queryString, cb) {
      //  sectorList;
      // console.log({sectorList});
      var results = queryString
        ? sectorList.filter(sect =>
            this.createSectorFilter(queryString.trim(), sect)
          )
        : sectorList;
      // console.log({ results });
      cb(results);
    },
    sectorSelected(sector) {
      this.regDataParams.deviceRequest.sector = `${sector.value}`;
    },
    packageSelected() {
      this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
      this.form.price = this.systemTypes.find(x => x.id == this.form.package)[
        "price"
      ];
      // this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      // this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(
      //   this.form.price
      // );
      // this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(
      //   this.form.price
      // );
      // console.log({
      //   form: this.calcSetup(this.form.price)
      // });
    },
    async refreshZohoToken() {
      const HTTP = this.$httpUtils.instance;
      let newToken = await HTTP.post("/zohos/refresh-zoho-token");
      this.zohoToken = newToken.data.token;
      this.showErrorMsg({
        message: "Token refreshed, Please reload page"
      });
      // this.loadAll();
    },
    async fetchPackageConfig() {
      const HTTP = this.$httpUtils.instance;
      return await HTTP.get("/package-configs");
    },
    loadAll(page = 1) {
      // console.log("++++++++++++++++++++++++++");
      // console.log(page);
      //  console.log(this.form)
      const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      let container = this;
      let collection = "Contacts?fields=Email,First_Name,Last_Name,Phone";
      if (page > 1) {
        collection =
          "Contacts?fields=Email,First_Name,Last_Name,Phone&page=" + page;
      }
      ZOHOTHTTP.get(`fetchAll`, {
        params: {
          collection
        }
      })
        .then(response => response.data["result"])
        .then(resultData => {
          let tempList = resultData["data"];
          // console.log(tempList);
          container.ZcontactList = [
            ...container.ZcontactList,
            ...tempList.map(x => ({
              ...x,
              value: x.First_Name
                ? `${x.First_Name} ${x.Last_Name}`
                : x.Last_Name
            }))
          ];
          container.contactList = container.ZcontactList;
          // console.log(container.ZcontactList);
          if (resultData["info"]["more_records"] == true) {
            this.loadAll(resultData["info"]["page"] + 1);
          }
        })
        .catch(e => {
          console.log("========Err=========");
          console.log(e);
          // this.refreshZohoToken();
        });
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      let container = this;
      //  filter={"include": ["installations"]} customer
      const url = `/users?filter[order]=id DESC`;
      HTTP.get(url)
        .then(response => {
          container.customerList = response.data.map(x => ({
            ...x,
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: `${x.firstName} ${x.lastName}`
          }));
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchSysTypes() {
      const HTTP = this.$httpUtils.instance;
      const url =
        "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url)
        .then(response => {
          this.systemTypes = response.data;
          // console.log({ systemTypes });
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    let ctx = this;
    ctx.regDataParams.deviceRequest.priceModel.amount = 4279069.77;
    ctx.regDataParams.deviceRequest.priceModel.amountVAT = ctx.getVatValue(
      ctx.regDataParams.deviceRequest.priceModel.amount
    );
    ctx.regDataParams.deviceRequest.priceModel.grandTotal =
      parseFloat(ctx.regDataParams.deviceRequest.priceModel.amount) +
      parseFloat(ctx.regDataParams.deviceRequest.priceModel.amountVAT);

    ctx.regDataParams.deviceRequest.priceModel.amountPaymentB4Delivery = ctx.getVatValue(
      ctx.regDataParams.deviceRequest.priceModel.grandTotal,
      90
    );
    ctx.regDataParams.deviceRequest.priceModel.amountBalanceAfterInstalation = ctx.getVatValue(
      parseFloat(ctx.regDataParams.deviceRequest.priceModel.grandTotal),
      10
    );
    console.error({ price: ctx.regDataParams.deviceRequest.priceModel });
  },
  async mounted() {
    let tmpPackageConfig = await this.fetchPackageConfig();
    this.packageConfigs = tmpPackageConfig["data"];
    this.regDataParams.deviceRequest = {
      ...this.regDataParams.deviceRequest,
      salesManager: `${this.getUserSession.firstName} ${this.getUserSession.lastName}`,
      salesManagerContact: `${this.getUserSession.phoneNumber}`
    };
    this.loadAll();
    this.fetchUsers();
    this.fetchSysTypes();
  }
};
</script>

<style lang="scss" scoped>
.container-fluid .page-content {
  padding: 0px !important;
}

.container-fluid .container-fluid {
  padding: 0px !important;
}
.el-form-item__label {
  text-align: left !important;
}
.el-select-dropdown__item {
  line-height: 20px;
  display: flex;
  flex-flow: column;

  span {
    line-height: 20px !important;
  }
}
.price-display {
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/proforma/index.vue